<template>
  <div>
    <div class="row h-row-inputBox">
      <div class="col-sm-4 h-col-inputBox">
        <div class="form-group">
          <div class="e-float-input">
            <div class="h-inputLit">环境名称:</div>
            <div class="h-inputLit">{{data.k8sName}}</div>
          </div>
          <div class="error"></div>
        </div>
      </div>
      <div class="col-sm-4 h-col-inputBox">
        <div class="form-group">
          <div class="e-float-input">
            <div class="h-inputLit">实例数:</div>
            <div class="h-inputLit">{{data.count}}</div>
          </div>
          <div class="error"></div>
        </div>
      </div>
      <div class="col-sm-4 h-col-inputBox">
        <div class="form-group">
          <div class="e-float-input">
            <div class="h-inputLit">创建时间:</div>
            <div class="h-inputLit">{{data.createTime}}</div>
          </div>
          <div class="error"></div>
        </div>
      </div>
    </div>

    <ejs-grid :dataSource="instanceData" ref="instanceGrid" :height="400">
      <e-columns>
        <e-column field="id" :visible="false"></e-column>
        <e-column field="dname" :headerText="$t('名称')" width="120" textAlign="Center"></e-column>
        <e-column
          field="deliverType"
          :headerText="$t('交付方式')"
          width="120"
          textAlign="Center"
          :valueAccessor="deliverTypeFormat"
        ></e-column>
        <e-column field="version" :headerText="$t('交付版本')" width="120" textAlign="Center"></e-column>
        <e-column
          field="createTime"
          :headerText="$t('创建时间')"
          width="120"
          textAlign="Center"
          type='date' format='yyyy-MM-dd HH:mm:ss'
        ></e-column>
      </e-columns>
    </ejs-grid>
  </div>
</template>
<script>
export default {
  name: "InstanceDetail",
  data() {
    return {
      instanceData: [],
      data: [],
      deliverTypeMap: new Map()
        .set(0, "Native")
        .set(1, "Image")
        .set(2, "Helm")
        .set(3, "Vm")
    };
  },
  mounted() {
    this.getInstanceList();
  },
  methods: {
    deliverTypeFormat(field, consistentData) {
      return this.deliverTypeMap.get(consistentData[field]);
    },
    getInstanceList() {
      this.axios
        .get("/lte/ems/deployed/queryDeployedInfoAll?envID=" + this.data.id)
        .then(res => {
          console.log(" res{}", res);
          if (res.status == 200) {
            const result = res.data.resultVal;
            result.forEach(item => {
                const re = item;
                re.createTime = parseInt(re.createTime, 10);
                });
            this.instanceData = result;
          }
        });
    },

    findEnv(data) {
      this.data = data;
      this.getInstanceList();
    },
    getSelectRole() {
      return this.$refs.instanceGrid.getSelectedRecords();
    }
  }
};
</script>
